import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { FaEdit } from "react-icons/fa";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import FtpBatchModalContent from "./ModalContent/FtpBatchModalContent";
import { useFTPExportBatchList, useFTPImportBatches } from "./hook/useFTPImportBatches";
import FtpExportModalContent from "./ModalContent/FtpExportModalContent";
type Props = {};

const FtpExportBatches = (props: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filtersState, setFiltersState] = useState<any>({
    page: 1,
    limit: 10,
    search: null,
  });
  const [selectedRow,setSelectedRow] = useState('')
  const [mode,setMode]=useState('')

  const { data: ftpExportBatchesData } = useFTPExportBatchList({
    enable: true,
    params:{
      page:filtersState.page,
      limit:filtersState.limit,
      search:filtersState.search
    }
  });

 

  const ftpBatchDataColumns =(handleEdit:(row:any)=>void)=> [
    {
      name: "Label",
      selector: (row: { Label: string }) => row.Label || "-",
      sortable: true,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "Next Date",
      selector: (row: { NextDate: string }) => row.NextDate ?? "-",
      sortable: true,
      minWidth: "150px",
      wrap: true,
    },
    {
      name: "FTP Path",
      selector: (row: { FtpPath: string }) => row.FtpPath || "-",
      sortable: true,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "Is enabled",
      selector: (row: { Isenabled: string }) =>
        row.Isenabled == "0" ? "No" : "Yes",
      sortable: true,
      minWidth: "150px",
      wrap: true,
    },
    {
      name: "Action",
      minWidth: "150px",
      cell: (row: any) => (
        <button
          onClick={()=>handleEdit(row)}
          className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
          style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
      ),
    },
  ];


  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };


  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleEdit=(row:any)=>{
setSelectedRow(row)
setMode('edit')
toggleModal()
  }

  const handleAdd=()=>{
    setMode('add')
    toggleModal()
  }


  const handleClose = () => setIsModalOpen(false);

  return (
    <div className="p-4">
      <PageHeader
        title="FTP Export Batches"
        buttons={[
          {
            label: "+ Add FTP Export Batches",
            onClick:()=> handleAdd(),
            color: "#2e8dd3",
          },
        ]}
      />

      <BasicDataTable
      dynamicHeightOnRowsPerPage={true}
        Title="FTP Export Batches"
        data={ftpExportBatchesData?.data?.FTPExportBatches || []}
        columns={ftpBatchDataColumns(handleEdit)}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        paginationTotalRows={
          ftpExportBatchesData?.data?.Pagination?.TotalCount || 0
        }
      />
      <RouteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={mode=='add'?"Add FTP Export Batch":"Edit FTP Export Batch"}
        size="md"
        content={
          <FtpExportModalContent
            handleClose={handleClose}
            selectedRow={selectedRow}
            mode={mode}
          />
        }
      />
    </div>
  );
};

export default FtpExportBatches;
